module.exports = __webpack_public_path__ + "img/4-5.fb5cb3cf.svg";